import { ColumnBlockComponent } from './column-block';
import { ColumnsBlockComponent } from './columns-block';

export function effects() {
  customElements.define('affine-columns', ColumnsBlockComponent);
  customElements.define('affine-column', ColumnBlockComponent);
}
